module.exports = __webpack_public_path__ + "img/M08.e125137e.png";